<template>
	<div class="index">
		<!-- 顶部导航 -->
		<van-nav-bar title="" left-text="" @click-left="toService" left-arrow fixed safe-area-inset-top>
      <template #right>
        <ChangeLanguage />
      </template>
		  <template #title>
		    <div class="van-image" style="width: 90px;">
		    	<!-- 关键图片使用预加载 -->
		    	<img 
					src="/img/logo.png" 
					class="van-image__img"
					alt="Site Logo"
					loading="eager"
					fetchpriority="high"
				/>
			</div>
		  </template>
		  <template #left>
		    <van-icon name="chat-o" size="26" />
		  </template>
		</van-nav-bar>

		<!-- 骨架屏 -->
		<HomeSkeleton v-if="isLoading" />

		<template v-else>
			<!-- Banner轮播 -->
			<div class="banner banners" style="margin-top: 5px;height: 10rem;" >
				<swiper class="swiper" :options="bannerSwiperOption">
				  <swiper-slide v-for="(v,key) in banners" :key="key">
						<a>
							<!-- Banner图片使用懒加载但优先加载 -->
							<img 
								:src="v.url" 
								class="banner_img"
								:alt="'Banner ' + (key + 1)"
								loading="lazy"
								:data-src="v.url"
								@load="handleImageLoad"
							/>
						</a>			      
				  </swiper-slide>
				  <!-- 空状态 -->
				  <div v-if="banners.length === 0" class="empty-banner">
					<van-empty description="暂无轮播图" />
				  </div>
				</swiper>
			</div>

			<!-- 公告区域 -->
			<div class="announcement-section">
				<div class="announcement-header">
					<van-icon name="volume-o" size="16" />
					<span class="announcement-title">公告</span>
				</div>
				<div class="announcement-content">
					<swiper class="announcement-swiper" :options="announcementSwiperOption">
					  <swiper-slide v-for="(v,key) in vip_list" :key="`announcement-${key}`">
						<span class="announcement-text">{{v}} {{$t('home.joinvip')}}</span>
					  </swiper-slide>
					  <!-- 空状态 -->
					  <div v-if="vip_list.length === 0" class="empty-announcement">
						<span class="announcement-text">{{$t('home.noAnnouncement')}}</span>
					  </div>
					</swiper>
				</div>
			</div>

			<!-- 热门公告区域 -->
			<div class="item">
				<div class="title">
					<span class="animate__animated animate__fadeIn">
						HOT
						<i style="font-size: 14px;">
							{{$t('home.gonggao')}}
						</i>
					</span>
				</div>
				<div class="girl">
					<div class="hot-announcement-container">
						<div class="hot-scroll-content">
							<div class="hot-item" v-for="(v,key) in movielist_0" :key="`hot-${key}`" @click="profile(v.id)">
								<div class="hot-image-wrapper">
									<!-- 热门区域图片使用懒加载 -->
									<img 
										:src="v.image" 
										:data-src="v.image"
										alt="热门公告" 
										class="hot-image"
										loading="lazy"
										@load="handleImageLoad"
									/>
									<div class="online-badge">
										<div class="online-dot"></div>
										<span class="online-text">on line</span>
									</div>
								</div>
							</div>
							<!-- 复制一份用于无缝滚动 -->
							<div class="hot-item" v-for="(v,key) in movielist_0" :key="`hot-copy-${key}`" @click="profile(v.id)">
								<div class="hot-image-wrapper">
									<img 
										:src="v.image" 
										:data-src="v.image"
										alt="热门公告" 
										class="hot-image"
										loading="lazy"
										@load="handleImageLoad"
									/>
									<div class="online-badge">
										<div class="online-dot"></div>
										<span class="online-text">on line</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 热门列表 -->
			<div class="item">
				<div class="title" style="padding-bottom: 10px;">
					<span class="animate__animated animate__fadeIn">
						{{$t('home.hotlist')}}
					</span>
				</div>
				<div class="tj">
					<ul>
						<li v-for="(v,key) in movielist_1" :key="`movie-${key}`" >
							<div class="left">
								<div class="image-wrapper">
									<!-- 用户头像使用懒加载 -->
									<img 
										:src="v.image" 
										:data-src="v.image"
										:alt="v.class_name" 
										loading="lazy"
										@load="handleImageLoad"
									/>
									<div class="profile-online-badge">
										<div class="online-dot"></div> -->
										<span class="online-text">on line</span>
									</div>
								</div>
								<p style="margin-top: 6px;">{{v.class_name}}</p>
							</div>
							<div class="right">
								<div class="badge-container">
									<span class="badge-item">
										<span class="van-badge__wrapper van-icon badge-icon">
											<img class="van-icon__image" src="/img/vipu.png" alt="VIP" />
										</span>
										{{$t('home.smrz')}}
									</span>
									<span class="badge-item">
										<span class="van-badge__wrapper van-icon badge-icon">
											<img class="van-icon__image" src="/img/vipu.png" alt="VIP" />
										</span>
										{{$t('home.videorz')}}
									</span>
								</div>
								<div class="tags-container">
									<span v-for="(val,index) in v.tags_arr" :key="index" class="tag">{{val}}</span>
								</div>
								<div class="info-container">
									<p class="star-rating">
										{{$t('home.star')}}：
										<span v-for="(numa,indexs) in v.star" :key="indexs" class="star"></span>
									</p>
									<div class="user-details">
										{{$t('home.sg')}}: {{v.sg}}cm {{$t('home.xw')}}：{{v.sw}}{{$t('home.diqu')}}：{{v.class_name}}
									</div>
								</div>
								<div class="apply-btn" @click="profile(v.id)">
									{{$t('home.apply')}}
								</div>
							</div>
						</li>
					</ul>
					<van-empty v-if="movielist_1.length === 0" description="暂无推荐内容" />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import cacheManager from '../../common/cache';
import ChangeLanguage from '@/i18n/change-language.vue';

// 懒加载组件
const HomeSkeleton = () => import('./components/HomeSkeleton.vue');

export default {
  name: 'HomeIndex',
  components: {
    ChangeLanguage,
    HomeSkeleton
  },
  data() {
    return {
      notice: "",
      banners: [],
      basicData: [],
      gameitem: [],
      movielist_0: [],
      movielist_1: [],
      vip_list: [],
      isLoading: true,
      isError: false,
      errorMessage: '',
      // 图片加载状态
      loadedImages: new Set(),
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        loop: false,
        speed: 1000,
        autoplay: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1
        }
      },
      vipSwiperOption: {
        direction: 'vertical',
        slidesPerView: 7,
        loop: true,
        speed: 1000,
        autoplay: true
      },
      announcementSwiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        spaceBetween: 0
      }
    };
  },
  methods: {
    /**
     * 高性能图片加载处理
     */
    handleImageLoad(event) {
      const img = event.target;
      const src = img.getAttribute('data-src') || img.src;
      
      // 标记图片已加载
      this.loadedImages.add(src);
      
      // 移除加载中的样式（如果有）
      img.classList.remove('image-loading');
      img.classList.add('image-loaded');
    },

    /**
     * 预加载关键图片
     */
    preloadCriticalImages() {
      // 预加载Logo和关键图标
      const criticalImages = [
        '/img/logo.png',
        '/img/vipu.png'
      ];
      
      criticalImages.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    },

    /**
     * 初始化图片懒加载观察器
     */
    initImageLazyLoad() {
      if ('IntersectionObserver' in window) {
        // 修复：移除未使用的 observer 参数
        const imageObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const dataSrc = img.getAttribute('data-src');
              
              if (dataSrc && !this.loadedImages.has(dataSrc)) {
                img.src = dataSrc;
                img.removeAttribute('data-src');
              }
              
              imageObserver.unobserve(img);
            }
          });
        });

        // 下一帧开始观察图片
        this.$nextTick(() => {
          document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
          });
        });
      } else {
        // 浏览器不支持 IntersectionObserver 的回退方案
        this.fallbackImageLoad();
      }
    },

    /**
     * 回退图片加载方案
     */
    fallbackImageLoad() {
      // 简单的回退：直接加载所有图片
      this.$nextTick(() => {
        document.querySelectorAll('img[data-src]').forEach(img => {
          const dataSrc = img.getAttribute('data-src');
          if (dataSrc && !this.loadedImages.has(dataSrc)) {
            img.src = dataSrc;
            img.removeAttribute('data-src');
          }
        });
      });
    },

    gotoMenu(router) {
      this.$router.replace(router)
    },
    
    toLottery(key, id) {
      this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id })
    },

    profile(id) {
      this.$router.push({ path: '/profile?id=' + id });
    },

    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast(this.$t('common.refresh'));
      }
    },

    toPlayVideo(id) {
      this.$router.push({ path: '/PlayVideo?id=' + id })
    },

    async onRefresh() {
      this.isLoading = true;
      this.loadedImages.clear();
      try {
        await this.getBasicConfig();
        this.$toast(this.$t('common.refreshSuccess'));
      } catch (error) {
        this.$toast(this.$t('common.refreshFailed'));
      } finally {
        this.isLoading = false;
      }
    },

    async getBasicConfig() {
      const cacheKey = 'basic_config';
      
      try {
        // 先尝试从缓存获取
        const cachedData = cacheManager.get(cacheKey);
        if (cachedData) {
          console.log('使用缓存的基本配置');
          this.processBasicData(cachedData);
          return;
        }
        
        // 缓存中没有，从API获取
        const response = await this.$http({
          method: 'get',
          url: 'sys_config'
        });
        
        this.processBasicData(response.data);
        
        // 缓存基本配置（1分钟）
        cacheManager.set(cacheKey, response.data, 60 * 1000);
        
      } catch (error) {
        console.error('获取基本配置失败:', error);
        this.isError = true;
        this.errorMessage = '加载失败，请重试';
        this.$toast(this.$t('common.loadFailed'));
      }
    },

    processBasicData(data) {
      this.basicData = data;
      this.vip_list = data.vip_list || [];
      this.getNotice(data);
      this.getBanner(data);
      this.getGameItem();
      this.getMovieList_0(data);
      this.getMovieList_1(data);
    },

    getNotice(data) {
      this.notice = data.notice || this.$t('home.noNotice');
    },

    async getGameItem() {
      const cacheKey = 'lottery_hot';
      
      try {
        // 先尝试从缓存获取
        const cachedData = cacheManager.get(cacheKey);
        if (cachedData) {
          console.log('使用缓存的游戏列表');
          this.gameitem = cachedData;
          return;
        }
        
        // 缓存中没有，从API获取
        const response = await this.$http({
          method: 'get',
          url: 'lottery_hot'
        });
        
        this.gameitem = response.data;
        
        // 缓存游戏列表（1分钟）
        cacheManager.set(cacheKey, response.data, 60 * 1000);
        
      } catch (error) {
        console.error('获取游戏列表失败:', error);
        this.gameitem = [];
      }
    },

    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0 || [];
    },

    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1 || [];
    },

    getBanner(data) {
      this.banners = data.banners || [];
    }
  },
  mounted() {
    // 初始化图片懒加载
    this.initImageLazyLoad();
    
    // 添加全局错误监听（轻量级）
    window.addEventListener('error', (e) => {
      if (e.target.tagName === 'IMG') {
        console.warn('图片加载失败:', e.target.src);
        // 不替换图片，保持原样，避免性能损耗
      }
    }, true);
  },
  async created() {
    // 预加载关键图片
    this.preloadCriticalImages();
    
    // 使用Promise.all并行加载数据
    await Promise.all([
      this.getBasicConfig()
    ]);
    this.isLoading = false;
    
    // 数据加载完成后初始化懒加载
    this.$nextTick(() => {
      this.initImageLazyLoad();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('error', () => {}, true);
  }
}
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

/* 移动端样式 - 强制所有屏幕都使用移动端样式 */
.index {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    position: relative;
    margin: 0 auto;
}

/* 强制所有屏幕都使用移动端布局 */
body {
    margin: 0;
    padding: 0;
    background: #f0f0f0;
    display: block;
}

/* 移除所有桌面端样式，只保留移动端样式 */

/* 图片加载优化样式 */
.image-loading {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

.image-loaded {
  opacity: 1;
  transition: opacity 0.3s ease;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 为图片添加加载状态 */
.hot-image,
.game-image,
.banner_img,
.image-wrapper img {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.hot-image.image-loaded,
.game-image.image-loaded,
.banner_img.image-loaded,
.image-wrapper img.image-loaded {
  opacity: 1;
}

/* 新增：公告区域样式 */
/* 修改公告区域样式 - 透明背景无边框 */
.announcement-section {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.1) !important; /* 透明背景 */
    margin: 12px 15px;
    border-radius: 12px;
    padding: 12px 16px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); 
    border: 1px solid rgba(0, 0, 0, 0.1); */
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(10px); /* 毛玻璃效果 */
    -webkit-backdrop-filter: blur(10px);
}

.announcement-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,0.2), transparent);
}

.announcement-header {
    display: flex;
    align-items: center;
    min-width: 60px;
    margin-right: 12px;
}

.announcement-header .van-icon {
    color: #000 !important; /* 黑色图标 */
    margin-right: 6px;
    filter: none;
}

.announcement-title {
    color: #000 !important; /* 黑色标题 */
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    text-shadow: none;
}

.announcement-content {
    flex: 1;
    height: 24px;
    overflow: hidden;
    position: relative;
}

.announcement-swiper {
    height: 100%;
}

.announcement-swiper .swiper-slide {
    display: flex;
    align-items: center;
    height: 24px;
}

.announcement-text {
    color: #000 !important; /* 黑色文字 */
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: none;
    opacity: 0.9;
}

.empty-announcement {
    display: flex;
    align-items: center;
    height: 100%;
}

/* 最简单的解决方案 */
.van-nav-bar {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%) !important;
    height: auto;
    min-height: 46px;
    padding-top: env(safe-area-inset-top);
    padding-bottom: 0;
}

/* 关键：增加更多顶部间距 */
.index {
    padding-top: calc(66px + env(safe-area-inset-top) + 20px); /* 增加到20px */
}

.banner.banners {
    margin-top: 0;
    /* 确保轮播图不会被任何元素遮挡 */
    position: relative;
}

.page-loading {
    display: flex;
    justify-content: center;
    padding: 40px 0;
}

.empty-banner,
.empty-vip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    font-size: 14px;
}

/* 热门公告区域新样式 - 纯图片版本 */
.hot-announcement-container {
    width: 100%;
    overflow: hidden;
    position: relative;
    margin-bottom: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
    border-radius: 12px;
    padding: 12px 0;
}

.hot-scroll-content {
    display: flex;
    animation: hotScroll 500s linear infinite;
    width: max-content;
}

.hot-scroll-content:hover {
    animation-play-state: paused;
}

.hot-item {
    flex-shrink: 0;
    width: 220px;
    height: 260px;
    margin: 0 8px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    background: white;
}

.hot-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.25);
}

.hot-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.hot-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.hot-item:hover .hot-image {
    transform: scale(1.1);
}

/* 绿色在线徽章样式 - 热门公告区域 */
.online-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 4px 8px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    animation: onlinePulse 2s infinite;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(34, 197, 94, 0.2);
    z-index: 1000;
}

.online-dot {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border-radius: 50%;
    margin-right: 4px;
    animation: dotPulse 1.5s infinite;
    box-shadow: 0 0 6px rgba(34, 197, 94, 0.6);
}

.online-text {
    font-size: 11px;
    font-weight: 600;
    color: #15803d;
    white-space: nowrap;
}

@keyframes onlinePulse {
    0% {
        box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    }
    50% {
        box-shadow: 0 2px 12px rgba(34, 197, 94, 0.5);
    }
    100% {
        box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    }
}

@keyframes dotPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
    }
    70% {
        box-shadow: 0 0 0 4px rgba(34, 197, 94, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    }
}

@keyframes hotScroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

/* 热门推荐列表图片容器 */
.image-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
}

/* 绿色在线徽章样式 - 热门推荐列表 */
.profile-online-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 4px 8px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    animation: onlinePulse 2s infinite;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(34, 197, 94, 0.2);
    z-index: 1000;
}

.profile-online-badge .online-dot {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border-radius: 50%;
    margin-right: 4px;
    animation: dotPulse 1.5s infinite;
    box-shadow: 0 0 6px rgba(34, 197, 94, 0.6);
}

.profile-online-badge .online-text {
    font-size: 11px;
    font-weight: 600;
    color: #15803d;
    white-space: nowrap;
}

/* 强制移除所有 #ebcaaf 颜色的遮挡元素 */
.left [style*="background-color: #ebcaaf"],
.left [style*="background:#ebcaaf"],
.left [style*="background: #ebcaaf"],
.left [style*="background-color:#ebcaaf"],
.left [style*="#ebcaaf"] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
}

/* 移除所有可能包含 #ebcaaf 颜色的span和i元素 */
.left > span,
.left span[style*="position"],
.left i[style*="position"],
.left span[style*="absolute"],
.left i[style*="absolute"] {
    display: none !important;
}

/* 移除所有绝对定位的可能遮挡元素 */
.left [style*="position: absolute"],
.left [style*="position:absolute"],
.left [style*="absolute"] {
    display: none !important;
}

/* 移除所有右上角的元素 */
.left [style*="top"],
.left [style*="right"] {
    background: transparent !important;
}

/* 确保图片显示正常 */
.image-wrapper img {
    display: block;
    width: 100%;
    border-radius: 8px;
    position: relative;
    z-index: 1;
}

/* 最强制的方法：隐藏所有不是图片和在线徽章的元素 */
.left > *:not(.image-wrapper):not(.profile-online-badge) {
    background-color: transparent !important;
}

/* 检查所有直接子元素 */
.left > span,
.left > i,
.left > div:not(.image-wrapper) {
    display: none !important;
}

/* 确保在线徽章在最前面 */
.profile-online-badge {
    z-index: 9999 !important;
}

/* 如果有伪元素遮挡 */
.left::before,
.left::after,
.image-wrapper::before,
.image-wrapper::after {
    display: none !important;
    content: none !important;
}

/* 热门游戏列表样式 */
.game-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    padding: 0 10px;
    margin-top: 10px;
}

.game-list li {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.game-list li:hover {
    transform: translateY(-5px);
}

.game-image-container {
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border: 2px solid rgba(255,255,255,0.1);
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    transition: all 0.3s ease;
    position: relative;
}

.game-list li:hover .game-image-container {
    box-shadow: 0 6px 20px rgba(0,0,0,0.25);
    border-color: rgba(255,255,255,0.3);
    transform: scale(1.05);
}

.game-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    transition: transform 0.3s ease;
}

.game-list li:hover .game-image {
    transform: scale(1.1);
}

.game-name {
    margin-top: 8px;
    font-size: 12px;
    color: #333;
    text-align: center;
    font-weight: 500;
    line-height: 1.2;
    transition: color 0.3s ease;
}

.game-list li:hover .game-name {
    color: #667eea;
}

/* 热门列表右侧文字样式优化 */
.tj {
  ul {
    padding: 0 12px;
    
    li {
      display: flex;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 16px;
      margin-bottom: 16px;
      padding: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.8);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
      }
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, #3498db, #8e44ad, #f093fb);
        border-radius: 16px 16px 0 0;
      }
    }
  }
}

/* 左侧内容区域调整 */
.left {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

/* 右侧内容区域美化 */
.right {
  flex: 1;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  .badge-container {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
    
    .badge-item {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #4a5568;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
      padding: 6px 12px;
      border-radius: 20px;
      border: 1px solid rgba(102, 126, 234, 0.2);
      font-weight: 500;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
      }
      
      .badge-icon {
        margin-right: 6px;
        
        .van-icon__image {
          width: 14px;
          height: 14px;
          filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
        }
      }
    }
  }
  
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;
    
    .tag {
      background: linear-gradient(135deg, #a8edea, #fed6e3);
      color: #2d3748;
      padding: 4px 10px;
      border-radius: 12px;
      font-size: 18px;
      font-weight: 600;
      border: 1px solid rgba(255, 255, 255, 0.6);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
      }
    }
  }
  
  .info-container {
    background: rgba(248, 250, 252, 0.8);
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 12px;
    border: 1px solid rgba(226, 232, 240, 0.6);
    backdrop-filter: blur(10px);
    
    .star-rating {
      color: #e53e3e;
      font-weight: 700;
      margin-bottom: 6px;
      font-size: 20px;
      display: flex;
      align-items: center;
      
      .star {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%23f6ad55" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>') no-repeat;
        margin: 0 2px;
        filter: drop-shadow(0 1px 1px rgba(0,0,0,0.2));
      }
    }
    
    .user-details {
      color: #718096;
      font-size: 22px;
      line-height: 1.5;
      font-weight: 500;
      background: linear-gradient(135deg, #4a5568, #718096);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  
  .apply-btn {
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    color: white;
    padding: 12px 24px;
    border-radius: 25px;
    text-align: center;
    font-weight: 700;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    position: relative;
    overflow: hidden;
    letter-spacing: 0.5px;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
      transition: left 0.6s;
    }
    
    &:hover::before {
      left: 100%;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
    }
  }
}

/* 空状态美化 */
.van-empty {
  padding: 40px 20px;
  
  .van-empty__image {
    width: 80px;
    height: 80px;
  }
  
  .van-empty__description {
    color: #a0aec0;
    font-size: 14px;
    margin-top: 12px;
  }
}

/* 响应式优化 - 只保留小屏幕优化 */
@media (max-width: 375px) {
    .banner.banners {
        height: 8rem;
    }
    
    .game-list {
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }
    
    .hot-item {
        width: 120px;
        height: 160px;
        margin: 0 6px;
    }
    
    .online-badge {
        padding: 3px 6px;
        border-radius: 10px;
    }
    
    .online-text {
        font-size: 10px;
    }
    
    .online-dot {
        width: 6px;
        height: 6px;
    }
    
    .profile-online-badge {
        padding: 3px 6px;
        border-radius: 10px;
    }
    
    .profile-online-badge .online-text {
        font-size: 10px;
    }
    
    .tj ul li {
        padding: 12px;
        margin-bottom: 12px;
    }
    
    .right {
        margin-left: 12px;
        
        .badge-container {
            gap: 8px;
            
            .badge-item {
                font-size: 11px;
                padding: 4px 10px;
            }
        }
        
        .apply-btn {
            padding: 10px 20px;
            font-size: 13px;
        }
    }
    
    /* 公告区域响应式 */
    .announcement-section {
        margin: 10px 12px;
        padding: 10px 12px;
    }
    
    .announcement-header {
        min-width: 50px;
        margin-right: 10px;
    }
    
    .announcement-title {
        font-size: 13px;
    }
    
    .announcement-text {
        font-size: 12px;
    }
}

@media (max-width: 320px) {
    .game-list {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    
    .hot-item {
        width: 120px;
        height: 160px;
        margin: 0 5px;
    }
    
    .online-badge {
        padding: 2px 4px;
    }
    
    .online-text {
        font-size: 9px;
    }
    
    .profile-online-badge {
        padding: 2px 4px;
    }
    
    .profile-online-badge .online-text {
        font-size: 9px;
    }
    
    /* 公告区域响应式 */
    .announcement-section {
        margin: 8px 10px;
        padding: 8px 10px;
    }
    
    .announcement-header {
        min-width: 45px;
    }
    
    .announcement-title {
        font-size: 12px;
    }
    
    .announcement-text {
        font-size: 11px;
    }
}

/* 优化图片样式 */
.van-image__img,
.banner_img {
    object-fit: cover;
}

/* 无障碍访问支持 */
@media (prefers-reduced-motion: reduce) {
    .hot-scroll-content {
        animation: none;
    }
    
    .hot-item:hover,
    .game-list li:hover,
    .tj ul li:hover {
        transform: none;
    }
    
    .apply-btn::before {
        display: none;
    }
    
    .online-badge,
    .profile-online-badge {
        animation: none;
    }
    
    .online-dot {
        animation: none;
    }
    
    .announcement-swiper {
        .swiper-wrapper {
            transition-duration: 0ms !important;
        }
    }
}

/* 动画性能优化 */
.hot-scroll-content {
    will-change: transform;
}

.hot-item {
    transform: translateZ(0);
}

/* 性能优化：减少重绘和回流 */
.index {
    contain: layout style paint;
}

.item {
    contain: layout;
}

/* 滚动性能优化 */
.hot-announcement-container {
    transform: translateZ(0);
}

/* 图片加载优化 */
.van-image__img,
.banner_img,
.hot-image,
.game-image {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}
</style>